<template>
  <slack-wrapper
    class="slack-wrapper"
    :sendTestMessageButtonDisabled="sendTestMessageButtonDisabled"
    @sendTestMessage="$emit('sendTestMessage')"
  >
    <div class="mb-2 text-wrapper" v-if="introText" v-html="introText"></div>
    <div class="mb-2"><span><strong>{{ title }}</strong></span></div>
    <div class="mb-2">
      <span class="slack-button"><strong>LinkedIn</strong></span>
      <span class="ml-1 slack-button"><strong>Facebook</strong></span>
      <span class="ml-1 slack-button"><strong>WhatsApp</strong></span>
      <span class="ml-1 slack-button"><strong>Messenger</strong></span>
      <span class="ml-1 slack-button"><strong>Twitter</strong></span>
    </div>
    <div class="mb-2">Unsure what to send? How about:</div>
    <div class="mb-2">
      <div class="text-wrapper" v-html="shareText"></div>
      <div><a :href="shareLink">{{ shareLink }}</a></div>
    </div>
  </slack-wrapper>
</template>

<script>
import SlackWrapper from './wrapper';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CampaignAdminCampaigns',
  components: {
    SlackWrapper,
  },
  props: {
    fromEmail: {
      type: String,
    },
    job: {
      type: Object,
    },
    contentShare: {
      type: Object,
    },
    inputs: {
      type: Object,
    }
  },
  computed: {
    ...mapRoot([ 'user' ]),
    title() {
      const { job, contentShare } = this;
      if (job && job.title) {
        return job.title;
      }
      if (contentShare && contentShare.title) {
        return contentShare.title;
      }
      return ' - ';
    },
    shareLink() {
      const { job, contentShare } = this;
      const { origin } = this.$root;
      const baseURL = origin.includes('localhost') ? 'https://referrals.reallinks.dev' : origin;
      if (job && job.id) {
        return `${baseURL}/jobs/${job.id}/share`;
      }
      if (contentShare && contentShare.id) {
        return `${baseURL}/content/${contentShare.id}/share`;
      }
      return ' - ';
    },
    introText() {
      const { inputs, replaceVariables } = this;
      if (inputs && inputs.INPUT_INTRODUCTION_TEXT) {
        return replaceVariables(inputs.INPUT_INTRODUCTION_TEXT);
      }
      return null;
    },
    shareText() {
      const { inputs, replaceVariables } = this;
      if (inputs && inputs.INPUT_SHARE_TEXT) {
        return replaceVariables(inputs.INPUT_SHARE_TEXT);
      }
      return ' - ';
    },
    sendTestMessageButtonDisabled() {
      const { job, contentShare, fromEmail } = this;
      return (!job && !contentShare) || !fromEmail || !fromEmail.includes('@');
    },
    variables() {
      const { job, contentShare, shareLink } = this;
      return {
        FIRST_NAME: 'John',
        LAST_NAME: 'Doe',
        FULL_NAME: 'John Doe',
        LEADERBOARD_POSITION: Math.round(Math.random() * 100),
        LEADERBOARD_POINTS: Math.round(Math.random() * 500),
        JOB_TITLE: (job || {}).title || ' - ',
        JOB_DESCRIPTION: (job || {}).excerpt || ' - ',
        JOB_SHARE_TEXT: `Work with me as a ${(job || {}).title || ' - '}`,
        JOB_MATCH_LINK: (job || {}).linkedInSearchURL || ' - ',
        CONTENT_TITLE: (contentShare || {}).title || ' - ',
        CONTENT_DESCRIPTION: (contentShare || {}).description || ' - ',
        CONTENT_SHARE_TEXT: 'We are hiring. Apply to one of our openings!',
        LEADERBOARD_FIRST_POINTS: 1356,
        LEADERBOARD_SECOND_POINTS: 1110,
        LEADERBOARD_THIRD_POINTS: 936,
        LEADERBOARD_FIRST_NAME: 'John Doe',
        LEADERBOARD_SECOND_NAME: 'Mary Doe',
        LEADERBOARD_THIRD_NAME: 'Steve Doe',
        LEADERBOARD_FIRST_PRIZE_TITLE: '£1000 Amazon Voucher',
        LEADERBOARD_SECOND_PRIZE_TITLE: '£500 Amazon Voucher',
        LEADERBOARD_THIRD_PRIZE_TITLE: '£200 Amazon Voucher',
        JOB_SHARE_LINK: shareLink,
        CONTENT_SHARE_LINK: shareLink,
        PLATFORM_LINK: origin.includes('localhost') ? 'https://referrals.reallinks.dev' : origin,
      };
    }
  },
  methods: {
    replaceVariables(text) {
      const { variables } = this;
      let newText = text;
      Object.keys(variables).forEach(key => {
        newText = newText.replace(new RegExp(`{{${key}}}`, 'g'), variables[key]);
      });
      return newText;
    },
  },
};
</script>

<style lang="scss">
.slack-wrapper {
  .slack-button {
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
    padding: 0.25rem 0.5rem;
    cursor: pointer;

    &:hover {
      background-color: #f6f6f6;
    }
  }
  .text-wrapper {
    p {
      margin-bottom: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/message-previews/slack/promote-content.vue